<script setup lang="ts">
import { useAlertMessage } from '../composables/useAlertMessage'
/**
 *  アラートメッセージを保持するComponent。(色彩を軽くしたバージョン)
 */
const {
  // data
  /** アラートメッセージの有無 */
  hasError,
  /** アラートメッセージ */
  message,
  // methods
  addAlertMessage,
  deleteAlertMessage
} = useAlertMessage()

defineExpose({
  addAlertMessage,
  deleteAlertMessage
})
</script>

<template>
  <div v-if="hasError" class="alert miia-alert-danger-light" style="text-align: left">
    <button type="button" class="close" @click="deleteAlertMessage">×</button>
    <!-- <button type="button" class="close" data-dismiss="alert" @click="deleteAlertMessage">×</button> -->
    <div style="display: flex">
      <span style="display: inline-block; vertical-align: top; padding: 0px 5px 0px 0px">
        <font-awesome-icon icon="exclamation-circle" />
      </span>
      <p
        style="
          font-size: 0.9rem;
          white-space: pre-wrap;
          word-wrap: break-word;
          overflow: break-word;
          margin: 0px;
        "
      >
        {{ message }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.miia-alert-danger-light {
  font-size: 1rem;
  color: #fb0020;
  background-color: rgba(251, 0, 32, 0.1);
  border: solid 1px rgba(251, 0, 32, 0.5);
  border-radius: 0px;
}
</style>
